<template>
  <el-container id="home">
    <el-header>
      <span>{{sysConfig.sysName}}-{{companyName}}</span>
      <div class="loginInfo">
        <span>Hi~{{loginName}}({{actualName}})</span>
        <span v-if="deptName">-{{deptName}}</span>
        <div class="headPic">
          <img :src="headPic?headPic:require('../assets/person-3.png')" />
        </div>
        <el-button type="primary" icon="el-icon-switch-button" circle @click="logout"></el-button>
      </div>
    </el-header>
    <el-container>
      <el-aside width="150px">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu v-for="item in menuList" :index="item.index.toString()" :key="item.index">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item-group v-if="item.children && item.children.length > 0">
              <el-submenu
                v-for="subItem in item.children"
                :index="subItem.index.toString()"
                :key="subItem.index"
                v-if="subItem.children && subItem.children.length > 0"
              >
                <template slot="title">{{subItem.name}}</template>
                <el-menu-item
                  v-for="subChild in subItem.children"
                  :index="subChild.index.toString()"
                  :key="subChild.index"
                  @click="goToPage(subChild.url,subChild.name)"
                >
                  <span>{{subChild.name}}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-for="subItem in item.children"
                :index="subItem.index.toString()"
                :key="subItem.index"
                v-if="!subItem.children"
                @click="goToPage(subItem.url,subItem.name)"
              >
                <span>{{subItem.name}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <el-breadcrumb class="bread-crumb" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{path: '/index'}">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              v-for="bread in breadList"
              v-bind:key="bread.name"
              :to="{path:bread.path}"
            >{{ routeNames[bread.path.replace('/','')] || bread.name }}</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="view-area">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-footer>
      <p>@reserved by MUME Co.Ltd</p>
      <p>木美技术服务</p>
    </el-footer>
  </el-container>
</template>

<script>
import httpRequest from "../utils/httpRequest";
import banduRoutes from '../router/bandu';
export default {
  name: "homePage",
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    }
  },
  data() {
    return {
      menuList: [],
      breadList: [],
      loginName: "",
      actualName: "",
      headPic: "",
      companyName: "",
      deptName: "",
      routeNames: {},
      sysConfig: {
        sysName: "",
        homepageLogo: ""
      }
    };
  },
  created() {
    this.loginName = this.getCookie("loginName");
    this.actualName = this.getCookie("actualName");
    this.headPic = this.getCookie("headPic");
    this.companyName = this.getCookie("companyName");
    this.deptName = this.getCookie("deptName");
    this.getModuleList();
    this.getBreadList();
    this.getSysConfig();
  },
  methods: {
    getSysConfig() {
      httpRequest.get("/api/sysConfig/getSysConfigByType?type=2").then(res => {
        if (res.data.code == 0) {
          this.sysConfig.sysName = res.data.obj.sysName
            ? res.data.obj.sysName
            : "卡券回收管理系统平台";
          this.sysConfig.homepageLogo = res.data.obj.homepageLogo;
          document.title = res.data.obj.shareTitle
            ? res.data.obj.shareTitle
            : this.sysConfig.sysName;
          if (res.data.obj.shareIcon) {
            var link = document.querySelector('link[rel*="icon"]')
            link.href = res.data.obj.shareIcon;
          }
        }
      });
    },
    getModuleList() {
      httpRequest.get("/api/user/getModuleList").then(res => {
        this.menuList = res.data.list;
        const localMenu = banduRoutes[0].children.filter(m=>!m.hideMenu).map((item,index)=>{
            return {
              index:10000+index,
              name: item.name,
              url:item.path
            }
          });
        const localMenu1 = banduRoutes[1].children.filter(m=>!m.hideMenu).map((item,index)=>{
            return {
              index:10000+index,
              name: item.name,
              url:item.path
            }
          });
        // this.menuList.push({
        //   index:999,
        //   name:'经销商管理-本地',
        //   children:localMenu
        // })
        // this.menuList.push({
        //   index:1000,
        //   name:'课本资源-本地',
        //   children:localMenu1
        // })
      });
    },
    getBreadList() {
      this.breadList = [];
      for (const routeInfo of this.$route.matched) {
        if (
          typeof routeInfo.name === "string" &&
          routeInfo.name !== "homePage" &&
          routeInfo.name !== "mainView"
        ) {
          this.breadList.push(routeInfo);
        }
      }
    },
    logout() {
      httpRequest.get("/api/user/logout").then(res => {
        this.setCookie("loginName", "", -1);
        this.setCookie("actualName", "", -1);
        this.setCookie("headPic", "", -1);
        this.$router.replace({ path: "/" });
      });
    },
    goToPage(url, name) {
      this.routeNames[url.replace("/", "")] = name;
      this.$router.push({ path: url });
    }
  },
  watch: {
    $route(to, from) {
      this.getBreadList();
    }
  }
};
</script>

<style scoped lang="less">
#home {
  height: 100%;
  background-color: rgb(244, 244, 244);
  a {
    text-decoration: none;
    color: #fff;
  }
  .el-header {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    line-height: 60px;
    background-color: #0073a3;
    color: #fff;
  }
  .el-aside {
    .el-menu {
      height: 100%;
    }
  }
  .el-main {
    min-width: 100%;
    padding: 0;
    margin: 0;
  }
  .bread-crumb {
    background-color: #fff;
    padding: 20px;
  }
  .view-area {
    background-color: #fff;
    padding: 20px;
    margin: 20px;
  }
  .el-footer {
    background-color: #eeeeee;
    text-align: center;
    p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .loginInfo {
    float: right;
    font-size: 16px;
    .headPic {
      float: right;
      width: 40px;
      height: 40px;
      background: #fff;
      padding: 5px;
      border-radius: 25px;
      margin: 5px 0 5px 20px;
      align-items: center;
      align-self: center;
      display: flex;
      justify-content: center;
      img {
        width: 36.5px;
      }
    }
  }
}
</style>
<style lang="less">
#home {
  .el-submenu .el-menu-item {
    min-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue